export const MILESTONE_KEY = {
  M1: "M1",
  M2: "M2",
  M3: "M3",
  M4: "M4",
};

export const MILESTONE_ID = {
  M1: "m1",
  M2: "m2",
  M3: "m3",
  M4: "m4",
};

export const M1_TITLE = "Incoming Inspection & Damage Assessment";
export const M2_TITLE = "Repair / Refurbishment Completed";
export const M3_TITLE = "Final Inspection & Certification Readiness";

export const EVIDENCE_SECTION_KEYS = [
  "dimensionalMeasurements",
  "ndtReports",
  "visualInspectionImages",
];

export const M2_EVIDENCE_SECTION_KEYS = [
  "postRepairMeasurements",
  "heatTreatmentReferences",
  "processConfirmation",
];

export const M3_EVIDENCE_SECTION_KEYS = ["finalInspectionReport"];

export const SENSITIVITY_LEVELS = ["confidential", "ip"];

export const MILESTONE_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
};
